import {
  UPDATE_DECLARATION_START,
  UPDATE_DECLARATION_SUCCESS,
  UPDATE_DECLARATION_FAILURE,
} from './types';

export const updateDeclarationStart = (payload) => ({
  type: UPDATE_DECLARATION_START,
  payload: payload,
})

export const updateDeclarationSuccess = (payload) => ({
  type: UPDATE_DECLARATION_SUCCESS,
  payload: payload,
})

export const updateDeclarationFailure = (payload) => ({
  type: UPDATE_DECLARATION_FAILURE,
  payload: payload,
})
